"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextSpeakerId = void 0;
const SpeakingMode_1 = require("../types/SpeakingMode");
/**
 * Returns whether or not a participant can take the stick during a discussion.
 */
function getNextSpeakerId(discussion) {
    const { speakingMode } = discussion;
    let nextSpeakerId = null;
    if (speakingMode === SpeakingMode_1.SpeakingMode.SEQUENCED) {
        nextSpeakerId = getNextSpeakerIdSequenced(discussion);
    }
    else if (speakingMode === SpeakingMode_1.SpeakingMode.NON_SEQUENCED) {
        nextSpeakerId = getNextSpeakerIdNonSequenced(discussion);
    }
    return nextSpeakerId || discussion.ownerId;
}
exports.getNextSpeakerId = getNextSpeakerId;
/**
 * Returns whether or not a participant can take the stick during a sequenced circle.
 * In sequenced circles, only the next person on the circle can take the stick.
 */
function getNextSpeakerIdSequenced(discussion) {
    const { participantSeatingOrder, connectedParticipantIds, stickHolderId } = discussion;
    const currentSpeakerSeatIndex = participantSeatingOrder.indexOf(stickHolderId);
    let nextSpeakerId = participantSeatingOrder.find((id, index) => id !== stickHolderId && index > currentSpeakerSeatIndex && connectedParticipantIds.includes(id));
    if (!nextSpeakerId) {
        nextSpeakerId = participantSeatingOrder.find(id => id !== stickHolderId && connectedParticipantIds.includes(id));
    }
    return nextSpeakerId || null;
}
/**
 * Returns whether or not a participant can take the stick during an non-sequenced circle.
 * In non-sequenced circles, the order the stick is passed depends on the order participants raise their hands.
 */
function getNextSpeakerIdNonSequenced(discussion) {
    const { connectedParticipantIds, handRaiseQueue } = discussion;
    // Find first connected participant with their hand up
    return handRaiseQueue.find(id => connectedParticipantIds.includes(id)) || null;
}
//# sourceMappingURL=getNextSpeakerId.js.map